if (!customElements.get('menu-category-grid')) {
  customElements.define(
    'menu-category-grid',
    class MenuCategoryGrid extends HTMLElement {
      connectedCallback() {
        this.handleSectionChange = this.handleSectionChange || this.render.bind(this);
        document.addEventListener('shopify:section:load', this.handleSectionChange);
        document.addEventListener('shopify:section:reorder', this.handleSectionChange);
        this.render();
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:section:load', this.handleSectionChange);
        document.removeEventListener('shopify:section:reorder', this.handleSectionChange);
      }

      render() {
        const templatesByHandle = new Map();
        const menuContentProductPushHandles = new Set();
        const targets = document.querySelectorAll('[data-menu-category-grid-target]');

        this.querySelectorAll('template[data-menu-item-handle]').forEach((template) => {
          const handle = template.dataset.menuItemHandle;
          if (!templatesByHandle.has(handle)) templatesByHandle.set(handle, []);
          templatesByHandle.get(handle).push(template);
        });

        document
          .querySelectorAll('menu-content-product-push template[data-menu-item-handle]')
          .forEach((template) => {
            const handle = template.dataset.menuItemHandle;
            if (handle && template.content.childElementCount) menuContentProductPushHandles.add(handle);
          });

        // The section lives in the header group while its targets live in the header drawer snippet.
        // Re-render every mount point so theme editor reloads cannot leave stale menu content behind.
        targets.forEach((target) => {
          const targetHandles = [
            target.dataset.menuCategoryGridTarget,
            target.dataset.menuCategoryGridTargetTitle,
          ].filter(Boolean);
          const hasMenuContentProductPush = targetHandles.some((handle) =>
            menuContentProductPushHandles.has(handle)
          );
          const templates = Array.from(
            new Set(targetHandles.flatMap((handle) => templatesByHandle.get(handle) || []))
          );
          const isTargetActive =
            !hasMenuContentProductPush && templates.some((template) => template.content.childElementCount);

          target.replaceChildren();
          target.hidden = !isTargetActive;
          target
            .closest('.menu-drawer__submenu')
            ?.classList.toggle('menu-drawer__submenu--with-menu-category-grid', isTargetActive);

          if (isTargetActive) {
            templates.forEach((template) => target.appendChild(template.content.cloneNode(true)));
          }
        });
      }
    }
  );
}
